import mitt from "mitt";
const eventBus = mitt();
function $emit(name, obj) {
    eventBus.emit(name, obj);
}
function $on(name, func) {
    eventBus.on(name, func);
}
function $off(name) {
    eventBus.off(name);
}
function $once(name, func) {
    const onceWrapper = (...args) => {
        func(...args);
        eventBus.off(name, onceWrapper);
    };
    eventBus.on(name, onceWrapper);
}
let EventBus = { $emit, $on, $off, $once };
export default EventBus;
